module.exports = __webpack_public_path__ + "static/media/makers.cc071d57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/makers.svg
// module id = 605
// module chunks = 0